// Filename - pages/index.js

import React from "react";
import styles from './about.module.css';

const Home = () => {
  return (
    <div>
      <h1 className={styles.h1}>Welcome</h1>
    </div>
  );
};

export default Home;
